export class Roles {
  static ADMIN = 1; // Admin
  static CONTENT_VIEW_ANY = 2; // Ver todo el contenido
  static CONTENT_VIEW_ANY_STATS = 4; // Ver estadísticas de todo el contenido
  static CONTENT_DOWNLOAD = 8; // Puede descargar contenido
  static AD_ANY_VIEW = 16; // Ver publicidad
  static AD_ANY_CREATE = 32; // Crear publicidad
  static CONTENT_CLIP_VIEW = 64; // Ver clips
  static CONTENT_CLIP_EDIT = 128; // Crear clips
  static INSIDER = 256; // Acceso a control
  static BALANCE_VIEW = 512; // Ver balance
  static PAYMENTS_VIEW = 1024; // Ver pagos
  static PAYMENTS_EDIT = 2048; // Editar pagos
  static RTMP_VIEW = 4096; // Ver RTMP
  static RTMP_EDIT = 8192; // Editar RTMP
  static ENCODER_BOX_VIEW = 8193; // Ver encoder box
  static ENCODER_BOX_EDIT = 8194; // Editar encoder box	
  static JOBS_VIEW = 10001; // Ver trabajos asignados
  static JOBS_EDIT = 10002; // Editar trabajos asignados
  static USERS_VIEW = 16384; // Ver usuarios
  static USERS_EDIT = 32768; // Editar usuarios
  static WORKTEAM_VIEW = 16384; // Ver equipo
  static WORKTEAM_EDIT = 32768; // Editar equipo
  static WORKTEAM_PERFORMANCE_VIEW = 65536; // Ver rendimiento del equipo
  static INVENTORY_VIEW = 131072; // Ver inventario
  static INVENTORY_EDIT = 262144; // Editar inventario
  static ROLES_VIEW = 524288; // Ver roles
  static ROLES_EDIT = 1048576; // Editar roles
  static CONTENT_VIEW_NO_CONCURRENCY_LIMIT = 2097152; // Ver contenido sin límite de concurrencia
  static OPENAI_CALL = 4194304; // Llamadas a OpenAI
  static TEAM_VIEW = 8388608; // Ver equipo
  static TEAM_EDIT = 16777216; // Editar equipo
  static CONTENT_VIEW_ALL = 33554432; // Ver todo el contenido
  static CONTENT_EDIT = 67108864; // Editar contenido
  static HOME_HERO_VIEW = 134217728; // Ver home hero
  static HOME_HERO_EDIT = 268435456; // Editar home hero
  static BANNERGEN_VIEW = 268435457; // Ver banners generados
  static BANNERGEN_EDIT = 268435458; // Editar banners generados
  static HOME_COMPETITIONS_VIEW = 536870912; // Ver home competitions
  static HOME_COMPETITIONS_EDIT = 1073741824; // Editar home competitions
  static CONTROL_WORKER = 2147483648; // Trabajador de control
}